import Link from 'next/link';
import { css } from '@emotion/core';
import {
  styled,
  textStyle,
  minimumWidth,
  pxToRem,
  Heading,
  Text,
} from '@feast-it/ui/light';

export const Container = styled.div`
  width: 100%;
  text-align: center;
`;

export const LocationLinksHeading = styled(Heading)(
  ({ theme }) => css`
    ${minimumWidth(theme.breakpoints.medium)} {
      ${textStyle(theme, 'headingExtraLarge')};
    }
  `
);

export const LocationLinksSubtitle = styled(Text)(
  ({ theme }) => css`
    margin-top: ${theme.spacing[2]};
  `
);

export const LocationLinksSubtitleLink = styled(Link)(
  ({ theme }) => css`
    ${textStyle(theme, 'bodyMedium', 'mediumBlue')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-underline-offset: ${pxToRem(4)};
    }
  `
);

export const LocationLinksNavigationMultiple = styled.nav(
  ({ theme }) => css`
    margin-top: ${theme.spacing[10]};
    column-gap: ${theme.spacing[9]};
    column-fill: balance;
    columns: 2;

    ${minimumWidth(theme.breakpoints.small)} {
      columns: 3;
    }
    ${minimumWidth(theme.breakpoints.medium)} {
      columns: 4;
    }
  `
);

export const LocationLinksNavigationSingle = styled.nav(
  ({ theme }) => css`
    margin-top: ${theme.spacing[10]};
  `
);

export const LocationLinksSection = styled.ul(
  ({ theme }) => css`
    break-inside: avoid; /* keep each section intact */
    margin: 0 0 ${theme.spacing[8]};
    padding-left: 0;
    list-style: none;
  `
);

// For single section - apply columns to the section itself
export const LocationLinksSectionSingle = styled.ul(
  ({ theme }) => css`
    margin: 0;
    padding-left: 0;
    list-style: none;
    column-gap: ${theme.spacing[9]};
    column-fill: balance;
    columns: 2;

    ${minimumWidth(theme.breakpoints.small)} {
      columns: 3;
    }
    ${minimumWidth(theme.breakpoints.medium)} {
      columns: 4;
    }

    > li {
      break-inside: avoid;
    }
  `
);

export const LocationLinkItem = styled.li(
  ({ theme }) => css`
    text-align: left;
    margin-bottom: ${theme.spacing[2]};
    min-height: ${theme.spacing[6]};
  `
);

export const LocationLink = styled(Link)(
  ({ theme }) => css`
    ${textStyle(theme, 'bodySmall', 'mediumBlue')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      text-underline-offset: ${theme.spacing[1]};
    }
  `
);

export const LocationText = styled.span(
  ({ theme }) => css`
    ${textStyle(theme, 'bodySmall', 'darkGrey')};
    min-height: ${theme.spacing[6]};
  `
);
